import { useIntl } from 'react-intl';
import { DesktopComputerIcon, CreditCardIcon, QuestionMarkCircleIcon } from '@heroicons/react/solid';
import SupportCard from 'src/Components/Support/SupportCard';
import { SecondaryButton } from '@luminalearning/components';
import env from 'src/env';
import { useEffect } from 'react';
import supportURL from 'src/utils/supportUrl';
import MeetingCard from 'src/Components/Support/MeetingCard';
import { useQuery } from '@apollo/client';
import GET_LOCALE from 'src/graphql/queries/intlQuery';
import MainLayout from './MainLayout';

const SupportDesk = () => {
    const intl = useIntl();
    const { data: locale } = useQuery(GET_LOCALE);

    useEffect(() => {
        document.title = intl.formatMessage({ id: 'LP_SUPPORT_DESK', defaultMessage: 'Support Desk' });
    }, [intl]);

    return (
        <MainLayout>
            <div className='pb-20'>
                <div className='justify-center flex flex-col items-center lg:items-start'>
                    <span className='text-headline-lg font-bold ' style={{ lineHeight: '45px' }}>
                        {
                            intl.formatMessage({
                                id: 'LP_SUPPORT_DESK',
                                defaultMessage: 'Support Desk',
                            })
                        }
                    </span>
                    <span className='text-label' style={{ lineHeight: '45px' }}>
                        {
                            intl.formatMessage({
                                id: 'LP_SUPPORT_DESK_SUB',
                                defaultMessage: 'Contact our Support Team for any assistance you might need',
                            })
                        }
                    </span>
                </div>
                <section className='xl:w-search flex flex-col md:flex-row sm:justify-center
                                    md:justify-center xl:justify-start mr-4 items-center'>
                    <a href={`${env.luminaLearningUlr}support`} target='_blank' rel='noopener noreferrer'>
                        <SupportCard
                            heading={
                                intl.formatMessage({
                                    id: 'LP_SUPPORT_PRODUCT_SERVICES',
                                    defaultMessage: 'Product & Services',
                                })
                            }
                            CardImage={DesktopComputerIcon}
                        />
                    </a>

                    <a href={env.billingAndPaymentUlr} target='_blank' rel='noopener noreferrer'>
                        <SupportCard
                            heading={
                                intl.formatMessage({
                                    id: 'LP_SUPPORT_BILLING',
                                    defaultMessage: 'Billing & Payments',
                                })
                            }
                            CardImage={CreditCardIcon}
                        />
                    </a>

                    <a href={env.luminaGlobalSupportUrl} target='_blank' rel='noopener noreferrer'>
                        <SupportCard
                            heading={
                                intl.formatMessage({
                                    id: 'LP_SUPPORT_GET_IN_TOUCH',
                                    defaultMessage: 'Get in touch about any other enquries',
                                })
                            }
                            CardImage={QuestionMarkCircleIcon}
                        />
                    </a>
                </section>
                <section className='w-70'>
                    <MeetingCard />
                </section>
                <section className='mt-10 flex flex-col'>
                    <div className='flex items-center'>
                        <img src='/img/knowledge-base-icon@2x.png' className='h-60'
                            alt={intl.formatMessage({ id: 'LP_KNOWLEDGE_BASE', defaultMessage: 'Knowledge Base' }) }
                        />
                        <span>
                            <h1 className='text-headline-reg font-bold mb-6'>
                                {
                                    intl.formatMessage({
                                        id: 'LP_CHECK_KNOWLEDGE_BASE',
                                        defaultMessage: 'Check out our Knowledge Base',
                                    })
                                }
                            </h1>
                            <p className='text-paragraph-reg'>
                                {
                                    intl.formatMessage({
                                        id: 'LP_CHECK_KNOWLEDGE_BASE_EXPLAIN',
                                        defaultMessage: 'Explore Knowledge Base for FAQs, tutorials and support resources',
                                    })
                                }
                            </p>
                        </span>
                    </div>
                    <a href={supportURL(locale.appLocale)} target='_blank' rel='noopener noreferrer'>
                        <SecondaryButton
                            text={
                                intl.formatMessage({
                                    id: 'LP_KNOWLEDGE_BASE',
                                    defaultMessage: 'Knowledge Base',
                                })
                            }
                            hasArrow={true}
                            direction='Right'
                            onClick={() => { /** noop */ }}
                            className='w-9 ml-6'
                        />
                    </a>
                </section>
            </div>
        </MainLayout>
    );
};

export default SupportDesk;